import { CONSTANTS } from '@sohohouse/platform-resources'

export default (bookings, eventCategories, localePath) => bookings.map(booking => {
  const category = eventCategories[booking.event.category]
  const { resourceType } = booking.event.resource

  const eventResource = {
    name: 'whats-on-details-id',
    params: { id: booking.event.id }
  }
  const eventImages = booking.event.images

  const inductionResource = {
    name: 'introduction-appointment'
  }
  const houseImages = booking.venue.house && booking.venue.house.houseImageSet
  const venueImages = {
    small: houseImages && houseImages.mediumPng,
    medium: houseImages && houseImages.mediumPng,
    large: houseImages && houseImages.largePng,
    xlarge: houseImages && houseImages.xlargePng
  }

  const isInduction = resourceType === CONSTANTS.EVENT_TYPES.INDUCTION
  const path = isInduction ? inductionResource : eventResource
  const images = isInduction ? venueImages : eventImages

  const guests = booking && booking.numberOfGuests > 0 ? booking.numberOfGuests : null

  const ticketless = booking.processed && booking.event && booking.event.isTicketless

  return {
    id: booking.id,
    category: category && category.name,
    iconUrl: category && category.icon.svg,
    fromDate: booking.event.startsAt,
    timezone: booking.venue.timeZone,
    description: booking.event.description,
    house: booking.venue.name,
    houseColor: booking.venue.colors.dark,
    images,
    name: booking.event.name,
    status: ticketless ? null : booking.status,
    ticketless,
    guests,
    to: localePath(path)
  }
})
